<template>
    <div class="redactor">
        <div ref="redactor"></div>
    </div>
</template>

<script>
    export default {
        props: {
            value: String,
            options: Object,
        },

        data() {
            return {
                redactor: null,
                defaultOptions: {
                    buttons: ['format', 'bold', 'italic', 'underline', 'link', 'ul', 'html'],
                    linkNewTab: true,
                    minHeight: '120px',
                    source: true,
                    toolbarFixed: false,
                    callbacks: {
                        changed: (content) => {
                            this.$emit('input', content);
                        },
                    },
                },
            };
        },

        watch: {
            value(value) {
                value = value || "";
                if (value !== this.redactor.source.getCode()) {
                    this.redactor.source.setCode(value);
                }
            },
        },

        mounted() {
            if (!window.$R) {
                throw "To use redactor component you need to include redactor.js on your own. This is necessary to keep bundle size low.";
            }
            this.redactor = window.$R(this.$refs.redactor, {...this.defaultOptions, ...this.options});
            this.redactor.source.setCode(this.value);
        },

        beforeDestroy() {
            window.$R(this.$refs.redactor, 'destroy');
        },
    };
</script>